// startupGateContext (W2-B/N-05) — der Gate-Status als eigenes, abhaengig-
// keitsfreies Modul. Vorher lebte er nur in StartupGateCoordinator.tsx; die
// Tour (tour/TourProvider.tsx) muss ihn jetzt ebenfalls lesen, und ein direkter
// Import des Koordinators haette einen Kreis gebildet
// (Koordinator → CompleteProfileGate → adoptionHandoff → TourProvider).
// Der Koordinator re-exportiert beides unveraendert — bestehende Importe
// (`from './StartupGateCoordinator'`) bleiben gueltig.

import { createContext, useContext } from 'react';

export type StartupGate = 'legal' | 'complete-profile' | 'push-hint' | 'native-push' | 'none';

/**
 * Welches Startup-Gate steht gerade? Default 'none', damit Komponenten
 * ausserhalb des Koordinators (Tests, isolierte Mounts) unveraendert laufen.
 */
export const StartupGateContext = createContext<StartupGate>('none');

export function useStartupGate(): StartupGate {
  return useContext(StartupGateContext);
}
